import { ISeatMatchRequestModel } from '../classes/request-model';
import { clearAllSeatRequests, saveSeatRequest } from '../helpers/local-storage-helpers';
import { getCurrentLanguage } from '../helpers/window-helpers';
import { IAppState } from '../reducers/index';


export interface ISeatInCartRequestModel {
    seatNumber: number;
    itemId: number;
    seatId: string;
    brandId: string;
}
export function createFilterRequestWithZone(currentState: IAppState): ISeatMatchRequestModel {
    const filterRequest = createFilterRequest(currentState);
    filterRequest.zoneId = getCurrentZoneId(currentState);
    return filterRequest;
}

export function createFilterRequest(currentState: IAppState, clearCache?: boolean): ISeatMatchRequestModel {

    var selectedLevels = currentState.venueLevelModel.venueLevels.filter(level => { return level.selected }).map(level => { return level.levelNumber });
    var availableLevels = currentState.venueLevelModel.venueLevels.filter(level => { return !level.disabled }).map(level => { return level.levelNumber });
    let seatMatchRequest: ISeatMatchRequestModel = {
        brandId: currentState.appSettingsModel.brandId,
        minPrice: currentState.priceRangeModel.minPrice,
        maxPrice: currentState.priceRangeModel.maxPrice,
        allowSeparatedSeats: false, //disabled until SmartSeat can actually support this
        itemId: currentState.appSettingsModel.itemId,
        itemType: currentState.appSettingsModel.itemType,
        requestedPriceTypes: currentState.priceTypesModel.priceTypes.map(priceType => {
            return {
                priceTypeId: priceType.priceTypeId,
                quantity: priceType.selectedQuantity
            }
        }),
        selectedVenueLevels: selectedLevels,
        selectedAllLevels: selectedLevels.length === availableLevels.length || selectedLevels.length === 0,
        allowAisleAccessSelected: currentState.additionalSeatingOptionModel.allowAisleAccessSelected,
        additionalSeatingOptions: currentState.additionalSeatingOptionModel.additionalSeatingOptions
            .map(additionalSeatingOption => {

                let selectedSeatingOptionIds = additionalSeatingOption.options.filter(seatingOption => {
                    return seatingOption.selected == true;
                }).map(seatingOption => {
                    return seatingOption.id;
                });

                const option = {
                    ...{},
                    seatingOptionGroupId: additionalSeatingOption.id,
                    numberRequested: additionalSeatingOption.groupSeatSelectedQuantity,
                    selectedSeatingOptionIds: selectedSeatingOptionIds,
                    groupSelected: additionalSeatingOption.groupSelected
                } as any;

                return option;
            }),
        additionalNotes: currentState.additionalSeatingOptionModel.additionalNotes,
        language: getCurrentLanguage(),
        filtersModified: currentState.applicationModel.filtersModified,
        zoneId: null,
        invalidateCache: clearCache,
        requestHash: crypto.randomUUID()
    };

    const appSettings = currentState.appSettingsModel;
    try {
        saveSeatRequest(appSettings.itemId, appSettings.itemType, JSON.stringify(seatMatchRequest));
    } catch (exception) {
        clearAllSeatRequests();
        console.log("LOG: LocalStorage is full (saving for item " + appSettings.itemId.toString());
    }
    return seatMatchRequest;
}

export function getCurrentZoneId(currentState: IAppState):number | null {
    if (currentState.appSettingsModel.displaySeatFee) {        
        return (+currentState.seatMatchResultModel.suggestedSeats[0].zoneId);        
    }
    return null;
}